import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fetchTime'
})
export class FetchTimePipe implements PipeTransform {
  
  transform(statusHistory: Array<any>, key: number): string {
    let timing = '';
    statusHistory.forEach(el => {
      if (el.status === key) {
        timing = el.createdAt;
      }
    });
    return timing;
  }
}